import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import userSelectors from '@/redux/user/userSelectors';

import useMatchMedia from '@/hooks/useMatchMedia';

import RouteNames from '@/router/routes';

import PersonalIcon from '@/images/nav_icons/personal-data.svg?react';
import FinanceIcon from '@/images/nav_icons/financial-profile.svg?react';
import DocumentsIcon from '@/images/nav_icons/documents.svg?react';
import SecurityIcon from '@/images/nav_icons/security.svg?react';

import BtnLogout from '../btnLogout';
import BtnLang from '../btnLang';

import s from './menuProfile.module.css';

function MenuProfile({ hideProfile, hideMenu }) {
  const i18n = useSelector(appSelectors.translation);
  const user = useSelector(userSelectors.user);

  const navigate = useNavigate();

  const [opened, setOpened] = useState(false);

  const handleClick = () => {
    setOpened(false);

    setTimeout(() => {
      hideProfile();
      hideMenu();
    }, 300);
  };

  const handleClickFinancial = () => {
    if (user?.status === 'active') {
      Notify.warning(i18n['To proceed, fill in the "Personal Data" section']);
    } else {
      navigate(`/${RouteNames.PROFILE}/${RouteNames.FINANCIAL_PROFILE}`);
      handleClick();
    }
  };

  const handleClickDocuments = () => {
    if (
      user?.status === 'active' ||
      user?.status === 'personal_data_verified'
    ) {
      Notify.warning(
        i18n['To proceed, fill in the "Financial profile" section'],
      );
      return;
    }

    if (user?.status === 'financial_profile_block') {
      Notify.warning('"Financial profile" is waiting for verification');
      return;
    }

    navigate(`/${RouteNames.PROFILE}/${RouteNames.DOCUMENTS}`);
    handleClick();
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  const { isMobile, isDesktop } = useMatchMedia();

  return (
    <div className={s.menu} data-open={opened}>
      <NavLink
        to={`/${RouteNames.PROFILE}/${RouteNames.PERSONAL_DATA}`}
        onClick={handleClick}
        className={s.navlink}
      >
        <PersonalIcon stroke="currentColor" />
        <span>{i18n['Personal data']}</span>
      </NavLink>
      <button
        type="button"
        onClick={handleClickFinancial}
        className={s.navlink}
      >
        <FinanceIcon stroke="currentColor" />
        <span>{i18n['Financial profile'] || 'Financial profile'}</span>
      </button>
      <button
        type="button"
        onClick={handleClickDocuments}
        className={s.navlink}
      >
        <DocumentsIcon fill="currentColor" />
        <span>{i18n.Documents}</span>
      </button>
      <NavLink
        to={`/${RouteNames.PROFILE}/${RouteNames.SETTINGS}`}
        onClick={handleClick}
        className={s.navlink}
      >
        <SecurityIcon stroke="currentColor" />
        <span>{i18n.Security || 'Security'}</span>
      </NavLink>

      <BtnLang onClick={isDesktop ? handleClick : () => {}} />

      {!isMobile && <BtnLogout />}
    </div>
  );
}

export default MenuProfile;

MenuProfile.propTypes = {
  hideProfile: PropTypes.func,
  hideMenu: PropTypes.func,
};
